import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "請勿重複下單!",
  "address list",
  "all orders",
  "Also need to click $ONE food",
  "appAmount",
  "appDiscount",
  "Are you sure you want to delete the address",
  "Bill Decimal",
  "Billing details",
  "cash coupon",
  "Choose your own time",
  "Click on the folding",
  "Click share order code",
  "Click to see the rest",
  "compile",
  "contact information",
  "contacts",
  "Copy_of_the",
  "Current discount",
  "Delete the address",
  "Delivery Menus",
  "discount coupon",
  "Empty_cart",
  "EndTime",
  "have selected",
  "history remark",
  "Invite your menus",
  "in all",
  "LastOrderTime",
  "List out",
  "my shopping cart",
  "name",
  "No orders",
  "No address",
  "Opening_time",
  "nape",
  "operation",
  "Order",
  "part",
  "order time",
  "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh",
  "Preferential use",
  "Remaining_QS",
  "Service amount",
  "sheets",
  "Sold",
  "Table_name",
  "The address details",
  "Today",
  "Unbind",
  "You don't have the coupon yet",
  "You haven't ordered your food yet",
  "Your order is empty",
  "Your order is empty~"
];

export default createLegacyModule(keys);
